import { useState, useEffect } from 'react'
import {
  FeatureFlagDefault,
  FeatureFlagName,
  FeatureFlagKey,
  FeatureFlagDevOverride,
} from '../../_constants/featureFlags'
import { FeatureFlagValue, fetchFeatureFlagStatus } from '../../services/featureFlagService/featureFlagService'

/**
 * React hook for accessing feature flags
 * @param flagName The feature flag to check
 * @returns FeatureFlagValue indicating the status of the feature flag
 */
export const useFeatureFlag = (flagName: FeatureFlagName): FeatureFlagValue => {
  const flagKey = FeatureFlagKey[flagName]
  const defaultValue = FeatureFlagDefault[flagName]
  const devOverrideValue = FeatureFlagDevOverride[flagName]

  // If an override is set in development, use it directly without fetching from the service
  if (process.env.NODE_ENV === 'development' && typeof devOverrideValue === 'boolean') {
    console.log(`Feature flag ${flagName} overridden to ${devOverrideValue} in development environment`)
    return { enabled: devOverrideValue }
  }

  const [flagValue, setFlagValue] = useState<FeatureFlagValue>()

  useEffect(() => {
    const checkFeatureFlag = async () => {
      try {
        const result = await fetchFeatureFlagStatus(flagKey, defaultValue)
        setFlagValue(result)
      } catch (error) {
        setFlagValue({ enabled: defaultValue })
      }
    }

    checkFeatureFlag()
  }, [])

  return flagValue
}
